export enum StylesTeamRoleTypes {
  Unknown = 0,
  Leader = 1,
  TeamMember = 2,
}
